import { Injectable } from '@angular/core';
import { IMultiselectOptions } from "libraries/module/formbuilder/fields/multiselect/multiselect.model";
import { EAirSearchFields } from "app_locobook/air-search/e-air-search-fields";
import { EHosts } from "libraries/enums/EHosts";
import { IHostAlias } from "libraries/service/resources/host-alias/host-alias.resource";
import { ILabelAndValue } from "libraries/interfaces/ILabelAndValue";

@Injectable({
    providedIn : 'root'
})
export class AirSearchHostFormHelperService {


    public manageFullServiceCarriersOnlyInHostList(isTravelportSelected: boolean, hostsList: IMultiselectOptions[], checkboxLabel: string): IMultiselectOptions[]{
        const fullServiceIndex: number = hostsList.findIndex((item: IMultiselectOptions): boolean =>
            item.value === EAirSearchFields.fullServiceCarriersOnly);

        if (isTravelportSelected && fullServiceIndex === -1) {
            const travelportHost: IMultiselectOptions = {
                label: checkboxLabel,
                value: EAirSearchFields.fullServiceCarriersOnly,
                isCheckbox: true
            };
           hostsList.splice(hostsList.findIndex((host: IMultiselectOptions): boolean =>
                host.value === EHosts.TRAVELPORT) + 1, 0, travelportHost);
        } else if (!isTravelportSelected && fullServiceIndex !== -1) {
           hostsList.splice(fullServiceIndex, 1);
        }
        return hostsList;
    }

    public transformHostsResponseToLabelValue(hostAliases: IHostAlias[]): ILabelAndValue[] {
        return (hostAliases || []).map((hostAlias: IHostAlias): ILabelAndValue => {
            return {label: hostAlias.alias, value: hostAlias.host};
        });
    }
}